import { render, staticRenderFns } from "./RoomNoLogin.vue?vue&type=template&id=10cc76eb&scoped=true&"
import script from "./RoomNoLogin.vue?vue&type=script&lang=js&"
export * from "./RoomNoLogin.vue?vue&type=script&lang=js&"
import style0 from "./RoomNoLogin.vue?vue&type=style&index=0&id=10cc76eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cc76eb",
  null
  
)

export default component.exports